export interface ExtraField {
  type: string
  text: string
  formId?: string
  style?: any
}

const addAfterFields: {[key: string]: ExtraField } = {
  privacy_policy_notice: {
    type: 'component',
    text: 'For information on how your data is processed, please read <a class="purple-link" href="https://www.kingsbridge.co.uk/fair-processing-notice/" target="_blank">Fair Processing Notice | Kingsbridge Insurance</a>',
  },
  payment_breakdown: {
    type: 'breakdown',
    text: '',
  },
  automatic_renewals: {
    type: 'label',
    text: `<strong>Automatic Renewal</strong><br>
    Your payment details will be securely stored to enable continuous payment authority.
    We may use these details to automatically renew your policy next year.
    This applies to payments by Direct Debit, Debit or credit card.
   If we automatically renew your policy you will be notified and a quotation sent to you before taking
    payment. Please call us if you do not wish us to renew your policy or if your payment details change.`,
  },
  coupon_message: {
    formId: 'coupon_message',
    type: 'component',
    style: {
      display: 'none',
    },
    text: 'Thanks! If your promotional code is valid, you\'ll receive your voucher after your 14 day cooling off period.',
  },
  direct_debit_terms: {
    formId: 'direct_debit_terms',
    type: 'label',
    style: {
      display: 'none',
    },
    text: window.kbSchema ? `<div class="mt-4">${window.kbSchema.directTerms}</div>` : '',
  },
};

export default addAfterFields;
